function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.iterator.js";
import React from 'react';
import { InputSelect } from '@isyc-react/form/modules/input/select';
import { InputNumber } from '@isyc-react/form/modules/input/number';
import { useTranslation } from 'react-i18next';
import { nstable } from "../../../i18n/namespaces";
import '@isyc-react/design/main';
import "./table-pagination.style.scss";
import { isMobile, isTablet } from '@isyc-react/core/device';

// TODO design, total items, new pagination ... etc.

const defaultPaginationSizes = [10, 20, 30, 40, 50];
// TODO accesibility and i18n / fix buttons > i
export const TablePagination = props => {
  const {
    instance: {
      canPreviousPage,
      canNextPage,
      pageCount,
      preGroupedRows,
      preFilteredRows,
      gotoPage,
      nextPage,
      previousPage,
      setPageSize,
      state: {
        pageIndex,
        pageSize
      }
    },
    pagination = {},
    totalCount: totalCountProp,
    filteredCount: filteredCountProp,
    hasMobileView = false
  } = props;
  const {
    select,
    sizes = defaultPaginationSizes
  } = pagination;
  const {
    t
  } = useTranslation(nstable.common);
  const filteredCount = filteredCountProp !== null && filteredCountProp !== void 0 ? filteredCountProp : preGroupedRows === null || preGroupedRows === void 0 ? void 0 : preGroupedRows.length;
  const totalCount = totalCountProp !== null && totalCountProp !== void 0 ? totalCountProp : preFilteredRows === null || preFilteredRows === void 0 ? void 0 : preFilteredRows.length;
  const pageNumberState = React.useState(null);
  const [pageNumber, setPageNumber] = pageNumberState;
  React.useEffect(() => {
    setPageNumber(pageIndex + 1);
  }, [pageIndex]);
  const sizeOptions = React.useMemo(() => sizes.map(size => ({
    value: size.toString(),
    label: t('table.controls.pagination.rows', {
      size
    })
  })), [sizes]);
  const onInputChangePage = React.useCallback(() => {
    let page = pageNumber !== null ? pageNumber - 1 : 0;
    if (page < 0) page = 0;else if (page > pageCount - 1) page = pageCount - 1;
    setPageNumber(page + 1);
    gotoPage(page);
  }, [pageIndex, pageCount, pageNumber]);
  return /*#__PURE__*/React.createElement("div", {
    className: "table-pagination"
  }, hasMobileView ? (!isMobile || isTablet) && /*#__PURE__*/React.createElement(PaginationRecord, {
    filteredCount: filteredCount,
    totalCount: totalCount
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PaginationRecord, {
    filteredCount: filteredCount,
    totalCount: totalCount
  })), /*#__PURE__*/React.createElement("div", {
    className: "table-pagination-controls"
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-pagination-arrow-controls"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "table-pagination-arrow-button",
    onClick: () => gotoPage(0),
    disabled: !canPreviousPage,
    "aria-label": "Go to first page"
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-chevron-double-left font-size-18"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "table-pagination-arrow-button",
    onClick: () => previousPage(),
    disabled: !canPreviousPage,
    "aria-label": "Go to previous page"
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-chevron-left font-size-18"
  })), /*#__PURE__*/React.createElement("div", {
    className: "page-numeration"
  }, t('table.controls.pagination.desc', {
    current: pageIndex + 1,
    total: pageCount
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "table-pagination-arrow-button",
    onClick: () => nextPage(),
    disabled: !canNextPage,
    "aria-label": "Go to next page"
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-chevron-right font-size-18"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "table-pagination-arrow-button",
    onClick: () => gotoPage(pageCount - 1),
    disabled: !canNextPage,
    "aria-label": "Go to last page"
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-chevron-double-right font-size-18"
  }))), hasMobileView ? (!isMobile || isTablet) && /*#__PURE__*/React.createElement(PaginationInputOptions, {
    pageNumberState: pageNumberState,
    onInputChangePage: onInputChangePage,
    select: select,
    pageSize: pageSize,
    setPageSize: setPageSize,
    sizeOptions: sizeOptions
  }) : /*#__PURE__*/React.createElement(PaginationInputOptions, {
    pageNumberState: pageNumberState,
    onInputChangePage: onInputChangePage,
    select: select,
    pageSize: pageSize,
    setPageSize: setPageSize,
    sizeOptions: sizeOptions
  })));
};
const PaginationInputOptions = props => {
  const {
    pageNumberState,
    onInputChangePage,
    select,
    pageSize,
    setPageSize,
    sizeOptions
  } = props;
  const [pageNumber, setPageNumber] = pageNumberState;
  const {
    t
  } = useTranslation(nstable.common);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "table-pagination-input-controls"
  }, /*#__PURE__*/React.createElement("div", {
    className: "goto-description"
  }, t('table.controls.pagination.goto')), /*#__PURE__*/React.createElement("div", {
    className: "goto-input"
  }, /*#__PURE__*/React.createElement(InputNumber, {
    allowNegative: false,
    allowDecimals: false,
    value: pageNumber,
    onChange: setPageNumber,
    onBlur: () => onInputChangePage(),
    onKeyDown: e => {
      if (e.key === 'Enter') onInputChangePage();
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "records-select"
  }, /*#__PURE__*/React.createElement(InputSelect, _extends({
    isSearchable: false,
    isClearable: false,
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: false,
    captureMenuScroll: false
  }, select, {
    value: {
      value: pageSize.toString(),
      label: t('table.controls.pagination.rows', {
        size: pageSize
      })
    },
    onChange: option => {
      if (option) setPageSize(parseInt(option.value));
    },
    options: sizeOptions
  })))));
};
const PaginationRecord = props => {
  const {
    filteredCount,
    totalCount
  } = props;
  const {
    t
  } = useTranslation(nstable.common);
  return /*#__PURE__*/React.createElement("div", {
    className: "text-muted"
  }, filteredCount !== totalCount && /*#__PURE__*/React.createElement(React.Fragment, null, filteredCount, " / "), totalCount, " ", totalCount === 1 ? t('table.controls.pagination.record') : t('table.controls.pagination.records'), ' ');
};